module.exports = __webpack_public_path__ + "assets/fonts/play.d0b61925.svg";